import React, { useRef } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { reactIcons } from "../../../utils/icons";

const CustomDatePicker = ({
  selectedDate,
  onChange,
  placeholder,
  className = "",
  label,
  disableFuture = false,
  minDate,
  readOnly = false,
  error = "",
  touched = false,
  showTimeSelect = false,
  placement = "bottom-start"
}) => {
  // const [showYearSelect, setShowYearSelect] = useState(false);

  const currentDate = new Date().toISOString().split("T")[0];
  const datePickerRef = useRef();

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  return (
    <div className={"w-full "}>
      {label && (
        <label className="block text-sm font-medium text-gray656 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <DatePicker
          ref={datePickerRef}
          wrapperClassName="w-full"
          selected={selectedDate}
          onChange={onChange}
          showTimeSelect={showTimeSelect}
          timeIntervals={15}
          timeFormat="HH:mm"
          dateFormat="yyyy-MM-dd"
          maxDate={disableFuture ? new Date() : undefined}
          minDate={minDate}
          className={`!w-full px-2 h-11 border rounded-lg focus:outline-none ${
            touched && error ? "border-" : "border-gray-300"
          } ${className} placeholder:text-[13px]`}
          placeholderText={placeholder || currentDate}
          showYearDropdown={true}
          scrollableYearDropdown={true}
          yearDropdownItemNumber={100}
          readOnly={readOnly}
          popperPlacement={placement}
          // renderCustomHeader={({
          //   date,
          //   changeYear,
          //   decreaseMonth,
          //   increaseMonth,
          //   prevMonthButtonDisabled,
          //   nextMonthButtonDisabled,
          // }) => {
          //   const years = Array.from({ length: 100 }, (_, i) => i + 1925);

          //   return (
          //     <div className="custom-header">
          //       <button
          //         onClick={decreaseMonth}
          //         disabled={prevMonthButtonDisabled}
          //       >
          //         {'<'}
          //       </button>

          //       <span onClick={() => setShowYearSelect((prev) => !prev)}>
          //         {date.getFullYear()}
          //       </span>

          //       {showYearSelect && (
          //         <select
          //           value={date.getFullYear()}
          //           onChange={({ target: { value } }) => {
          //             changeYear(value);
          //             setShowYearSelect(false);
          //           }}
          //         >
          //           {years.map((year) => (
          //             <option key={year} value={year}>
          //               {year}
          //             </option>
          //           ))}
          //         </select>
          //       )}

          //       <button
          //         onClick={increaseMonth}
          //         disabled={nextMonthButtonDisabled}
          //       >
          //         {'>'}
          //       </button>
          //     </div>
          //   );
          // }}
        />
        <button
          type="button"
          onClick={handleIconClick}
          className="absolute right-3 bottom-3 text-xl text-gray-500"
        >
          {reactIcons.calender}
        </button>
      </div>
      {touched && error && (
        <div className="text-red-500 text-[12px] font-poppins mt-1">
          {error}
        </div>
      )}
    </div>
  );
};

CustomDatePicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  disableFuture: PropTypes.bool,
  readOnly: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  error: PropTypes.string,
  showTimeSelect: PropTypes.bool,
  touched: PropTypes.bool,
  placement: PropTypes.oneOf([
    "auto",
    "top",
    "bottom",
    "right",
    "left",
    "top-start",
    "top-end",
    "bottom-start",
    "bottom-end",
    "right-start",
    "right-end",
    "left-start",
    "left-end"
  ])
};

export default CustomDatePicker;
